export const INITIAL_STATE = "INITIAL_STATE";
export const MODAL_QR = "MODAL_QR";
export const LOCATION_URL = "LOCATION_URL";